exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".init-tipsModal_content_2IVuX p{\n    text-align: center;\n    font-size: 20px;\n    font-weight: bold;\n}\n\n.init-tipsModal_btn_25QQY{\n    display: -webkit-box;\n    display: -webkit-flex;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-justify-content: space-around;\n        -ms-flex-pack: distribute;\n            justify-content: space-around;\n    margin-top: 40px;\n}\n\n.init-tipsModal_btn_25QQY span{\n    padding: 10px 20px;\n    color: #fff;\n    border-radius: 4px;\n    font-size: 1rem;\n    background: #0081EF;\n    cursor: pointer;\n    white-space: nowrap;\n}\n\n.init-tipsModal_btn_25QQY span:last-child{\n    background-Color: #FFB41F;\n    border: 1px solid #FFB41F;\n}", ""]);

// exports
exports.locals = {
	"content": "init-tipsModal_content_2IVuX",
	"btn": "init-tipsModal_btn_25QQY"
};